export default "<narwhalia-my-swarm-sidebar class=\"sidebar\"></narwhalia-my-swarm-sidebar>\r\n<narwhalia-my-swarm-list></narwhalia-my-swarm-list>\r\n";